module.exports = __webpack_public_path__ + "static/2situation-5a263dbf64940d143af58fe51ed33718.png";